export default __webpack_public_path__ + "static/media/actions-enable.6417ea55.png";